import {
  Label,
  Text,
  TextArea as AriaTextArea,
  TextField,
  TextFieldProps,
} from 'react-aria-components';
import { cn } from '~/lib/utils';
import { CustomFieldError } from './Common';

export interface TextAreaProps extends TextFieldProps {
  className?: string;
  classNameLabel?: string;
  classNameInput?: string;
  label?: string;
  description?: string;
  errorMessage?: string;
  isLocked?: boolean;
}

function TextArea({
  className,
  classNameLabel,
  classNameInput,
  label,
  description,
  errorMessage,
  isRequired,
  ...props
}: TextAreaProps) {
  return (
    <TextField
      {...props}
      className={cn('flex flex-col gap-1.5 w-full disabled:opacity-40', className)}
      isRequired={isRequired}
      isInvalid={!!errorMessage}
    >
      {!!label && (
        <Label className={cn('text-sm font-medium text-input-label', classNameLabel)}>
          {label} {isRequired && '*'}
        </Label>
      )}

      <AriaTextArea
        className={cn(
          'min-h-44 bg-input-background border border-input-border rounded-xl px-4 py-3 w-full text-[15px] leading-[1.8]',
          'text-foreground focus:border-input-border-focused focus:shadow-input-focus focus-visible:outline-0 placeholder:text-input-placeholder disabled:text-gray-500',
          'data-invalid:border-error',
          'data-readonly:pointer-events-none',
          classNameInput,
        )}
      />

      {description && <Text slot="description">{description}</Text>}
      <CustomFieldError errorMessage={errorMessage} />
    </TextField>
  );
}

export default TextArea;
